import request from '@/utils/request'

export function store(data) {
  return request({
    url: 'reservations/create',
    method: 'post',
    data
  })
}

export function confirmReservation(data) {
  return request({
    url: 'reservations/confirm',
    method: 'post',
    data
  })
}

export function sendConfirmReservationEmail(reservation_id) {
  return request({
    url: 'reservations/send-confirm-email/' + reservation_id,
    method: 'post'
  })
}

// get all seats left
export function getAvailableSeats(locationId, dates, timezoneId, seatTypeOptionId) {
  if (!dates) {
    dates = dates.join(',');
  }
  return request({
    url: 'locations/' + locationId + '/' + dates + '/available-seats?timezone_id=' + timezoneId + '&seat_type_option_id=' + seatTypeOptionId,
    method: 'get'
  })
}

// get all reservations
export function getReservations(user_id) {
  return request({
    url: 'reservations',
    method: 'get'
  })
}

// get all reservations confirmation
export function getConfirmation(id) {
  return request({
    url: 'reservations/confirmation/' + id,
    method: 'get'
  })
}

// cancel reservation
export function cancelReservation(reservation_id, data) {
  return request({
    url: 'reservations/cancel/' + reservation_id,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/reservation.js